export default __webpack_public_path__ + "static/media/zapicon_Condominios.7395218f.svg";